import {
    Box,
    CircularProgress,
    Grid,
    Link,
    List,
    ListItem,
    Typography,
} from '@deere/fuel-react';
import { Breadcrumbs } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AlertBox } from '../../components/AlertBox';
import { JobDetails } from '../../components/JobDetails.jsx';
import { ASSIGNMENT_TYPE } from '../../constants.js';
import { LoggedInContext } from '../../context/LoggedInContext';
import { errorBannerFromResponse } from '../../utils/errorBanner';
import styles from './WorkforceMyJobBidsHistory.module.css';

const ClosedBidRow = ({ myBidHist }) => {
    return (
        <ListItem className={styles.jobBidRow}>
            <Grid container item xs={12} className={styles.jobBidRowInner}>
                <Grid item xs={12} sm={6}>
                    {myBidHist.assignmentType === ASSIGNMENT_TYPE.ASSIGNED && (
                        <>
                            <span className={styles.boldData}>
                                {' '}
                                {myBidHist.workforceJobBid.name}
                            </span>
                            <span>
                                - Seniority:
                                {myBidHist.workforceJobBid.seniorityDate}{' '}
                            </span>
                        </>
                    )}
                    {myBidHist.assignmentType ===
                        ASSIGNMENT_TYPE.NO_QUALIFIED_BIDDER && (
                        <span className={styles.boldData}>
                            {' '}
                            No Qualified Bidder
                        </span>
                    )}
                </Grid>
            </Grid>
        </ListItem>
    );
};

export const WorkforceMyJobBidsHistoryDetails = () => {
    const { jobNumber } = useParams();
    const [bid, setBid] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [alertMsg, setAlertMsg] = useState();
    const [alertVariant, setAlertVariant] = useState(false);
    const { makeRequest, authState } = useContext(LoggedInContext);

    useEffect(() => {
        let ignore = false;
        const fetchActiveSelectedBid = async () => {
            setIsLoading(true);
            try {
                const bidResponse = await makeRequest(
                    process.env.REACT_APP_API_ENDPOINT +
                        '/job/jobDetails/' +
                        jobNumber
                );
                if (!ignore) {
                    if (bidResponse.status === 200) {
                        const bidDetails = await bidResponse.json();
                        setBid(bidDetails);
                    } else {
                        setAlertMsg(
                            errorBannerFromResponse(
                                bidResponse,
                                'We are unable to retrieve active bidders for this job. Please try again later.'
                            ).message
                        );
                        setAlertVariant('error');
                    }
                    setIsLoading(false);
                }
            } catch (err) {
                setAlertMsg(
                    errorBannerFromResponse(
                        err,
                        'We are unable to retrieve this job bid. Please try again later.'
                    ).message
                );
                setAlertVariant('error');
            }
        };

        fetchActiveSelectedBid();

        // cleanup function that will ignore future results of fetch triggered by the useEffect hook
        return () => {
            ignore = true;
        };
    }, [jobNumber, authState, makeRequest]);

    return (
        <div className={styles.pageLevelParent}>
            <Box spacing={6} className={styles.pageLevelContent}>
                <Breadcrumbs aria-label="Breadcrumbs">
                    <Link href="/my-bid-history">Bid History</Link>
                    <Typography color="textPrimary">Job {jobNumber}</Typography>
                </Breadcrumbs>
                {alertVariant && (
                    <Box className={styles.spaceOnTop}>
                        <AlertBox msg={alertMsg} variant={alertVariant} />
                    </Box>
                )}
                {!isLoading && bid && (
                    <Box className={styles.boxForButton}>
                        <Typography
                            variant="h1"
                            className={styles.pageLevelHeading}
                        >
                            #{jobNumber}
                        </Typography>
                    </Box>
                )}
                {isLoading && (
                    <CircularProgress
                        size="lg"
                        variant="indeterminate"
                        title={'Loading'}
                    />
                )}
                {!isLoading && bid && <JobDetails bidObj={bid} />}
                <Grid
                    container
                    spacing={4}
                    className={styles.biddersGridSection}
                >
                    <Grid item sm={12}>
                        <Typography
                            variant="h4"
                            className={styles.pageLevelHeading}
                        >
                            Successful Bidders
                        </Typography>
                    </Grid>

                    {!isLoading && bid && bid.assignmentList && (
                        <List style={{ width: '100%' }}>
                            {bid.assignmentList.map((myBidHist, index) => {
                                return (
                                    <ClosedBidRow
                                        myBidHist={myBidHist}
                                        key={index}
                                    />
                                );
                            })}
                        </List>
                    )}
                </Grid>
            </Box>
        </div>
    );
};
